
import { format } from "date-fns";
import { ru } from "date-fns/locale";

// Преобразуем PostgreSQL interval в секунды
export const extractSeconds = (interval: unknown): number => {
  if (!interval) return 0;
  
  // Если interval - строка, пытаемся извлечь секунды
  if (typeof interval === 'string') {
    try {
      // Для строки в формате "HH:MM:SS"
      if (interval.includes(':')) {
        const parts = interval.split(':');
        if (parts.length === 3) {
          return parseInt(parts[0]) * 3600 + parseInt(parts[1]) * 60 + parseInt(parts[2]);
        }
      }
      
      // Для строки в формате "X seconds"
      if (interval.includes('seconds')) {
        const secondsMatch = interval.match(/(\d+) seconds/);
        return secondsMatch ? parseInt(secondsMatch[1]) : 0;
      }
      
      // Для строки в формате "X hours Y minutes Z seconds"
      let totalSeconds = 0;
      
      const hoursMatch = interval.match(/(\d+) hours?/);
      if (hoursMatch) totalSeconds += parseInt(hoursMatch[1]) * 3600;
      
      const minutesMatch = interval.match(/(\d+) minutes?/);
      if (minutesMatch) totalSeconds += parseInt(minutesMatch[1]) * 60;
      
      const secondsMatch = interval.match(/(\d+) seconds?/);
      if (secondsMatch) totalSeconds += parseInt(secondsMatch[1]);
      
      return totalSeconds;
    } catch (e) {
      console.error("Error parsing interval:", e);
      return 0;
    }
  }
  
  return 0;
};

// Преобразуем PostgreSQL interval в минуты
export const extractMinutes = (interval: unknown): number => {
  if (!interval) return 0;
  return Math.round(extractSeconds(interval) / 60);
};

export const formatDate = (dateString: string) => {
  try {
    return format(new Date(dateString), 'dd MMMM yyyy, HH:mm', { locale: ru });
  } catch (e) {
    return dateString;
  }
};
